import styled from 'styled-components';

const FilterStyle = styled.div`
	&.filterCont {
		position: relative;
		z-index: 2;

		.filterScrollWrap {
			overflow-x: auto;
			overflow-y: hidden;
			touch-action: pan-x;
			-webkit-overflow-scrolling: touch;
			cursor: grab;

			&:active,
			&.isDragging {
				cursor: grabbing;
			}
			margin-bottom: var(--titleToContent);

			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
			}

			.filterRow {
				display: flex;
				justify-content: flex-start;
				min-width: 100%;
				width: max-content;
			}

			/* &::-webkit-scrollbar {
				height: 4px;
				mix-blend-mode: difference;
			}

			&::-webkit-scrollbar-thumb {
				border-radius: 100px;
				mix-blend-mode: difference;
				background: linear-gradient(to right, var(--color1) var(--containerPaddingLR), var(--color2) var(--containerPaddingLR), var(--color2) calc(100% - var(--containerPaddingLR)), var(--color1) 10%);
			} */

			.filterWrap {
				display: flex;
				width: max-content;
				box-sizing: border-box;
				padding-left: var(--containerPaddingLR);
				padding-right: var(--containerPaddingLR);

				.filtersItem {
					cursor: pointer;
					scroll-snap-align: center;
					border-radius: 37px;
					border: 2px solid var(--color2);
					margin-right: var(--sp2x);
					opacity: 0;
					position: relative;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: var(--sp1x) var(--sp4x);
					text-transform: capitalize;

					&.active {
						background-color: var(--color2);
						color: var(--color1);

						.textVisible {
							font-style: var(--ffItalic);
						}
					}

					&:last-child {
						margin-right: 0;
					}

					.textHide {
						opacity: 0;
						visibility: hidden;
						white-space: pre;
					}

					.textVisible {
						white-space: pre;
						position: absolute;
					}

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover:not(.active) {
								.textVisible {
									font-style: var(--ffItalic);
								}
							}
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.filterScrollWrap {
				.filterRow {
					justify-content: flex-end;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.filterScrollWrap {
				.filterWrap {
					.filtersItem {
						margin-right: var(--sp2-5x);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			.filterScrollWrap {
				width: 100%;
				margin-left: auto;
				margin-right: auto;

				.filterWrap {
					.filtersItem {
						margin-right: var(--sp4x);
					}
				}
			}
		}
	}
`;

export default FilterStyle;
